import { Gallery, Video } from 'iconsax-react';
import { cn } from '@src/design-system/helpers';
import {
  isAnnouncementImageMime,
  isAnnouncementVideoMime,
} from '../utils/upload-announcement-media';

type AnnouncementTypeBadgeProps = {
  mimeType?: string | null;
};

export function AnnouncementTypeBadge({ mimeType }: AnnouncementTypeBadgeProps) {
  if (!mimeType) return <span>-</span>;

  const isVideo = isAnnouncementVideoMime(mimeType);
  const isImage = isAnnouncementImageMime(mimeType);

  if (!isVideo && !isImage) return <span>-</span>;

  const label = isVideo ? 'Video' : 'Image';
  const Icon = isVideo ? Video : Gallery;

  return (
    <span
      className={cn(
        'inline-flex h-8 items-center gap-1 rounded-full px-3 text-sm font-normal',
        isVideo
          ? 'bg-yellow-50 text-yellow-600'
          : 'bg-blue-50 text-blue-500'
      )}
    >
      <Icon
        size={16}
        variant='Outline'
        className='shrink-0'
      />
      {label}
    </span>
  );
}
